export const getImageAsPngBlob = async (imageUrl: string): Promise<Blob> => {
  const img = new Image();
  const c = document.createElement('canvas');
  const ctx = c.getContext('2d');
  return new Promise((resolve) => {
    img.onload = function () {
      c.width = img.naturalWidth;
      c.height = img.naturalHeight;
      ctx?.drawImage(img, 0, 0);
      c.toBlob(
        (blob) => {
          if (blob) {
            return resolve(blob);
          }
        },
        'image/png',
        1,
      );
    };
    img.crossOrigin = 'anonymous';
    img.src = imageUrl;
  });
};

/**
 * Whether the given file name has a PDF extension, ignoring case.
 */
export const isPdfFileName = (fileName?: string): boolean =>
  !!fileName?.toLowerCase().endsWith('.pdf');

export const getFileFromUrl = async (url): Promise<File> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Image fetch failed');
  }
  const blob = await response.blob();
  return new File([blob], 'url', { type: blob.type });
};

export const dataUrlToBlob = (dataUrl: string): Blob => {
  const [meta, data] = dataUrl.split(',');
  const isBase64 = meta.endsWith(';base64');
  const mimeEnd = isBase64 ? meta.length - ';base64'.length : undefined;
  const mime = meta.substring(meta.indexOf(':') + 1, mimeEnd).split(';')[0];
  const binaryString = isBase64 ? atob(data) : decodeURIComponent(data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime || 'application/octet-stream' });
};

// downloads a blob to the user's device via a synthetic anchor click; iOS Safari requires an
// actual blob: URL here — it silently drops the download for large data: URIs
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
